import { debounce } from 'lodash-es';

class Twitter {
  constructor(app) {
    this.app = app;
    this.libraryLoaded = false;

    this.initEvents();
  }

  initEvents() {
    $(document).on('bvm_twitter_load_library', () => {
      this.injectWidgetsLibrary();
    });

    $(document).on('bvm_front_ready', () => {
      this.deferWidgets(this.tweetsAreAbove);
    });

    $(document).on('scroll', debounce(() => {
      this.deferWidgets(this.tweetsAreVisible);
    }, 250, { 'leading': true, 'maxWait' : 250 }));

    $(document).on('bvm_blocks_dynamic_articles_item_loaded', () => {
      this.initWidgets();
    });
  }

  injectWidgetsLibrary() {
    if (this.libraryLoaded) {
      return;
    }

    this.libraryLoaded = true;

    window.twttr = (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0],
        t = window.twttr || {};
      if (d.getElementById(id)) return t;
      js = d.createElement(s);
      js.async= true;
      js.id = id;
      js.src = "https://platform.twitter.com/widgets.js";
      fjs.parentNode.insertBefore(js, fjs);

      t._e = [];
      t.ready = function(f) {
        t._e.push(f);
      };
      return t;
    }(document, "script", "twitter-wjs"));
  }

  tweetsAreAbove(tweets) {
    return tweets.offset().top < $(window).scrollTop() + $(window).height()
  }

  tweetsAreVisible(tweets) {
    return window.bvm.app.utils.isVisibleExperimental(tweets, 500)
  }

  deferWidgets(shouldBeInjectScript) {
    if (this.libraryLoaded) {
      return;
    }

    const tweets = $('.twitter-tweet');

    if (! tweets.length) {
      return;
    }

    if (shouldBeInjectScript(tweets)) {
      this.injectWidgetsLibrary();
    }
  }

  initWidgets() {
    if (! this.libraryLoaded || ! window.twttr) {
      return false;
    }

    window.twttr.widgets?.load();
  }

  async getTweets(args) {
    const params = new URLSearchParams();

    if (args.nonce) {
      params.append('nonce', args.nonce);
    }

    if (args.gender) {
      params.append('gender', args.gender);
    }

    if (args.limit) {
      params.append('limit', args.limit);
    }

    if (args.league) {
      params.append('league', args.league);
    }

    if (args.local) {
      params.append('local', args.local);
    }

    if (args.page) {
      params.append('page', args.page);
    }

    if (args.sport) {
      params.append('sport', args.sport);
    }

    if (args.team) {
      params.append('team', args.team);
    }

    if (args.divisions) {
      for (let i = 0; i < args.divisions.length; i++) {
        params.append('divisions[]', args.divisions[i]);
      }
    }

    if (args.conferences) {
      for (let i = 0; i < args.conferences.length; i++) {
        params.append('conferences[]', args.conferences[i]);
      }
    }

    if (args.conferencesIds) {
      for (let i = 0; i < args.conferencesIds.length; i++) {
        params.append('conferencesIds[]', args.conferencesIds[i]);
      }
    }

    const response = await this.app.api.get('social/tweets', params);

    if (response.isSuccess()) {
      return {
        total: response.getTotal(),
        data: response.getData(),
      };
    } else {
      console.error(response.getMessage());
      return {
        total: 0,
        data: [],
      };
    }
  }
}

export default Twitter;
